import { AxiosResponse } from "axios";
import { App, AppDetails,ShopifyConnect,WoocommerceConnect } from "./appStore.slice"; // Adjust the path as necessary
import { coreAxios } from "../../../Utils";
import { getHttpService } from "../../../Services";
import { APPSTORE_ENDPOINTS } from "../../../Services/Apis/Endpoints";
import { AppConfig } from "../../../Config/app-config";
export class CoreService {
  static httpService = getHttpService(coreAxios);
  static getAvailableApps = (payload:any): Promise<
    AxiosResponse<{ data: App[]; status: boolean }>
  > => {
    // const { query, installed } = payload;
    const { query, installed,integration } = payload;
  
    // Construct the query parameters in one variable
    const queryParams = new URLSearchParams();
    
    if (installed) {
      queryParams.append('installed', installed);
    }
    if (integration) {
      queryParams.append('integration',integration);
    }
  
    if (query) {
      queryParams.append('query', query);
    }
  
    // Convert the queryParams object to a string and append to the URL
    const queryString = queryParams.toString() ? `?${queryParams.toString()}` : '';
  
    return CoreService.httpService.get({
      url: `${APPSTORE_ENDPOINTS.AVAILABLE_APPS}${queryString}`,
    });
  };
  static getInstalledApps = (): Promise<
    AxiosResponse<{ data: App[]; status: boolean }>
  > => {
    return CoreService.httpService.get({
      url: `${APPSTORE_ENDPOINTS.AVAILABLE_APPS}?installed=true`,
    });
  };
  static getAppDetails = (
    id: string
  ): Promise<AxiosResponse<{ data: AppDetails; status: boolean }>> => {
    return CoreService.httpService.get({
      url: `${APPSTORE_ENDPOINTS.APP_DETAILS}/${id}`,
    });
  };

  static getOpenAiKeyStatus = (): Promise<any> => {
    return CoreService.httpService.get({
      url: `${APPSTORE_ENDPOINTS.OPENAI_KEY}`,
    });
  };

  static saveOrUpdateOpenAiKey = (key: string, model: string): Promise<any> => {
    return CoreService.httpService.post({
      // url: APPSTORE_ENDPOINTS.OPENAI_KEY,
      url: `${APPSTORE_ENDPOINTS.OPENAI_KEY}`,
      data: { openai_api_key: key, model: model },
    });
  };

  static deleteOpenAiKey = (): Promise<any> => {
    return CoreService.httpService.httpDelete({
      url: `${APPSTORE_ENDPOINTS.OPENAI_KEY}`,
    });
  };
  // ************** Woocommerce apis *******************
  static postConnectWoocommerceApp = (
    data: any
  ): Promise<AxiosResponse<{ data: WoocommerceConnect; status: boolean }>> => {
    return CoreService.httpService.post({
      url: `${APPSTORE_ENDPOINTS.WOOCOMMERCE_CONNECT}`,data
    });
  };
  
  // ************** Shopify apis *******************
  static postConnectShopifyApp = (
    data: any
  ): Promise<AxiosResponse<{ data: ShopifyConnect; status: boolean }>> => {
    return CoreService.httpService.post({
      url: `${APPSTORE_ENDPOINTS.SHOPIFY_CONNECT}`,data
    });
  };
  static postConnectShopifyAppManually = (
    data: any
  ): Promise<AxiosResponse<{ data: ShopifyConnect; status: boolean }>> => {
    return CoreService.httpService.post({
      url: `${APPSTORE_ENDPOINTS.SHOPIFY_CONNECT_MANUAL}`,data
    });
  };
  //****************************************************
  // ************** Facebook Lead Setting Page *******************
  static getFacebookAccountDeatils = async (
  ): Promise<AxiosResponse<{}>> => {
    try {
      // Build URL with query parameters using URLSearchParams
      const url = new URL(`${process.env.REACT_APP_FACEBOOK_DOMAIN}${APPSTORE_ENDPOINTS.GET_FACEBOOK_ACCOUNT_DEATILS}`);

      const response = await fetch(url.toString(), {
        method: 'GET',
        headers: {
          "Content-Type": "application/json",
          "geta-host": AppConfig.getLoggedInData()?.data?.geta_host,
        },
      });

      const responseData = await response.json();
      return responseData;
    } catch (error) {
      console.error('Error fetching Facebook connected page list:', error);
      throw error;
    }
    return CoreService.httpService.get({
      url: ``,
    });
  };

  static getFacebookConnectedPageList = async (
    data: any
  ): Promise<AxiosResponse<{ data: AppDetails; status: boolean }>> => {
    try {
      // Build URL with query parameters using URLSearchParams
      const url = new URL(`${process.env.REACT_APP_FACEBOOK_DOMAIN}${APPSTORE_ENDPOINTS.GET_FACEBOOK_CONNECTED_PAGE_LIST}`);

      const params = new URLSearchParams();
      if (data?.search) params.append('search', data.search);
      params.append('limit', data.limit);
      params.append('offset', data.offset);

      // Append params to the URL
      url.search = params.toString();

      const response = await fetch(url.toString(), {
        method: 'GET',
        headers: {
          "Content-Type": "application/json",
          "geta-host": AppConfig.getLoggedInData()?.data?.geta_host,
        },
      });

      const responseData = await response.json();
      return responseData;
    } catch (error) {
      console.error('Error fetching Facebook connected page list:', error);
      throw error;
    }
  };

  static getSyncStatus = async (): Promise<AxiosResponse<{data: any, status: boolean}>> => {
    return CoreService.httpService.get({
      url: `${APPSTORE_ENDPOINTS.GET_SYNC_STATUS}`,
    });
  }

  static getSyncPastList = async (
    data: any
  ): Promise<AxiosResponse<{ data: AppDetails; status: boolean }>> => {
    try {
      // Build URL with query parameters using URLSearchParams
      const url = new URL(`${process.env.REACT_APP_FACEBOOK_DOMAIN}${APPSTORE_ENDPOINTS.GET_SYNC_PAST_LEADS}`);

      const params = new URLSearchParams();
      if (data?.value !== "ALL") {
        params.append('start_date', data.startDate);
        params.append('end_date', data.endDate);
      }

      const response = await fetch(url.toString(), {
        method: 'POST',
        body: JSON.stringify(data),
        headers: {
          "Content-Type": "application/json",
          "geta-host": AppConfig.getLoggedInData()?.data?.geta_host,
        },
      });

      const responseData = await response.json();
      return responseData;
    } catch (error) {
      console.error('Error fetching Sync Past Lead:', error);
      throw error;
    }
  };

  static refreshFacebookLeadPage = async (
    data: any
  ): Promise<AxiosResponse<{ data: AppDetails; status: boolean }>> => {
    try {
      // Build URL with query parameters using URLSearchParams
      const url = new URL(`${process.env.REACT_APP_FACEBOOK_DOMAIN}${APPSTORE_ENDPOINTS.REFRESH_FACEBOOK_LEAD_PAGE}`);

      const response = await fetch(url.toString(), {
        method: 'GET',
        headers: {
          "Content-Type": "application/json",
          "geta-host": AppConfig.getLoggedInData()?.data?.geta_host,
        },
      });

      const responseData = await response.json();
      return responseData;
    } catch (error) {
      console.error('Error fetching Sync Past Lead:', error);
      throw error;
    }
  };

  static disconnectFacebook = async (
    data: any
  ): Promise<AxiosResponse<{ data: AppDetails; status: boolean }>> => {
    return CoreService.httpService.post({
      url: `${APPSTORE_ENDPOINTS.DISCONNECT_FACEBOOK}`, data
    });
  };


  static getFacebookConnectedPageFormList = async (
    data: any
  ): Promise<AxiosResponse<{ data: AppDetails; status: boolean }>> => {
    try {
      // Build URL with query parameters using URLSearchParams
      const url = new URL(`${process.env.REACT_APP_FACEBOOK_DOMAIN}${APPSTORE_ENDPOINTS.GET_FACEBOOK_CONNECTED_PAGE_FORM_LIST}` + data.form_id + "/lead-forms");

      const params = new URLSearchParams();
      if (data?.search) params.append('search', data.search);
      if (data?.status !== "ALL") {
        params.append('status', data?.status);
      }
      if (data?.mapping_status !== "ALL") {
        params.append('mapping_status', data?.mapping_status === "MAPPED" ? "true" : "false");
      }
      // if (data?.mapping_status !== "All") params.append('mapping_status', data?.mapping_status);
      params.append('limit', data.limit);
      params.append('offset', data.offset);

      // Append params to the URL
      url.search = params.toString();

      const response = await fetch(url.toString(), {
        method: 'GET',
        headers: {
          "Content-Type": "application/json",
          "geta-host": AppConfig.getLoggedInData()?.data?.geta_host,
        },
      });

      const responseData = await response.json();
      return responseData;
    } catch (error) {
      console.error('Error fetching Facebook connected page list:', error);
      throw error;
    }
  };
  static refreshFacebookLeadForms = async (
    data: any
  ): Promise<AxiosResponse<{ data: AppDetails; status: boolean }>> => {
    try {
      // Build URL with query parameters using URLSearchParams
      const url = new URL(`${process.env.REACT_APP_FACEBOOK_DOMAIN}${APPSTORE_ENDPOINTS.GET_FACEBOOK_CONNECTED_PAGE_FORM_LIST}` + data?.form_id + "/sync-lead-forms");

      const response = await fetch(url.toString(), {
        method: 'GET',
        headers: {
          "Content-Type": "application/json",
          "geta-host": AppConfig.getLoggedInData()?.data?.geta_host,
        },
      });

      const responseData = await response.json();
      return responseData;
    } catch (error) {
      console.error('Error fetching Sync Past Lead:', error);
      throw error;
    }
  };
  static enableDisableFacebookLeadForms = async (
    data: any
  ): Promise<AxiosResponse<{ data: AppDetails; status: boolean }>> => {
    try {
      // Build URL with query parameters using URLSearchParams
      const url = new URL(`${process.env.REACT_APP_FACEBOOK_DOMAIN}${APPSTORE_ENDPOINTS.GET_FACEBOOK_CONNECTED_PAGE_FORM_LIST}` + data?.form_id + "/lead-forms/update-all-status?status=" + data?.status);

      const response = await fetch(url.toString(), {
        method: 'PUT',
        headers: {
          "Content-Type": "application/json",
          "geta-host": AppConfig.getLoggedInData()?.data?.geta_host,
        },
        body: null
      });

      const responseData = await response.json();
      return responseData;
    } catch (error) {
      console.error('Error fetching Sync Past Lead:', error);
      throw error;
    }
  };
  static enableDisableSingleFacebookLeadForm = async (
    data: any
  ): Promise<AxiosResponse<{ data: AppDetails; status: boolean }>> => {
    try {
      // Build URL with query parameters using URLSearchParams
      const url = new URL(`${process.env.REACT_APP_FACEBOOK_DOMAIN}${APPSTORE_ENDPOINTS.GET_FACEBOOK_CONNECTED_PAGE_FORM_LIST}` + data?.page_id + "/lead-forms/" + data?.form_id + "/update-status?status=" + data?.status);

      const response = await fetch(url.toString(), {
        method: 'PUT',
        headers: {
          "Content-Type": "application/json",
          "geta-host": AppConfig.getLoggedInData()?.data?.geta_host,
        },
        body: null
      });

      const responseData = await response.json();
      return responseData;
    } catch (error) {
      console.error('Error fetching Sync Past Lead:', error);
      throw error;
    }
  };
  static getFormDetails = async (
    data: any
  ): Promise<AxiosResponse<{ data: AppDetails; status: boolean }>> => {
    try {
      // Build URL with query parameters using URLSearchParams
      const url = new URL(`${process.env.REACT_APP_FACEBOOK_DOMAIN}${APPSTORE_ENDPOINTS.GET_FACEBOOK_CONNECTED_PAGE_FORM_LIST}` + data?.page_id + "/lead-forms/" + data?.form_id);

      const response = await fetch(url.toString(), {
        method: 'GET',
        headers: {
          "Content-Type": "application/json",
          "geta-host": AppConfig.getLoggedInData()?.data?.geta_host,
        },
      });

      const responseData = await response.json();
      return responseData;
    } catch (error) {
      console.error('Error fetching Sync Past Lead:', error);
      throw error;
    }
  };
  static setMappingFields = async (
    data: any
  ): Promise<AxiosResponse<{ data: AppDetails; status: boolean }>> => {
    try {
      console.log("data", data);
      // Build URL with query parameters using URLSearchParams
      const url = new URL(
        `${process.env.REACT_APP_FACEBOOK_DOMAIN}${APPSTORE_ENDPOINTS.GET_FACEBOOK_CONNECTED_PAGE_FORM_LIST}${data?.page_id}/lead-forms/${data?.form_id}/update-mapping`
      );

      const response = await fetch(url.toString(), {
        method: 'PUT',
        headers: {
          "Content-Type": "application/json",
          "geta-host": AppConfig.getLoggedInData()?.data?.geta_host,
        },
        body: JSON.stringify(data?.payload), // Ensure payload is stringified
      });

      const responseData = await response.json();
      return responseData;
    } catch (error) {
      console.error('Error fetching Sync Past Lead:', error);
      throw error;
    }
  };

}